<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Cute" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Colorito</label>
                            <span v-if="isReadOnly">{{ jsonDataCute.colorito }}</span>
                            <b-form-select v-else v-model="jsonDataCute.colorito" :options="coloritoOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Integrità</label>
                            <span v-if="isReadOnly">{{ jsonDataCute.integrita }}</span>
                            <b-form-select v-else v-model="jsonDataCute.integrita" :options="integritaOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona Opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Descrizione Integrità</label>
                            <span v-if="isReadOnly">{{ jsonDataCute.integritaDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataCute.integritaDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Edemi</label>
                            <span v-if="isReadOnly">{{ jsonDataCute.edemi }}</span>
                            <b-form-select v-else v-model="jsonDataCute.edemi" :options="edemiOptions" :disabled="isReadOnly" :value="null">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona Opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Edemi presenti: </label>
                            <b-row>
                                <b-col cols="auto" v-for="edemi in edemiDettagliOptions" :key="'edemi-' + edemi.id" class="sa-switch-select-element">
                                    <b-form-checkbox switch :disabled="isReadOnly || jsonDataCute.edemi !== 'PRESENTI'" v-model="selectedEdemi" :value="edemi.voce" @change="onSelectCheckBox" :key="listKey">
                                        <span style="font-weight: normal">{{ edemi.voce }}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Note</label>
                            <span v-if="isReadOnly">{{ jsonDataCute.noteCute }}</span>
                            <b-form-textarea v-else v-model="jsonDataCute.noteCute" :readonly="isReadOnly" max-rows="10" rows="7"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    props: {
        isReadOnly: {
            type: Boolean,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataCute: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    colorito: "",
                    integrita: "",
                    integritaDescrizione: "",
                    edemi: "",
                    noteCute: "",
                    listaSchedaCuteDettagli: [],
                };
            },
        },
    },
    data() {
        return {
            pathResourceSchedaEsameObiettivoGeneraleCute: "/rsaschedaesameobiettivogeneralecute",
            pathResourceDizionario: "/rsadizionario",
            edemiDettagliOptions: [],
            listKey: 0,
            selectedEdemi: [],
            coloritoOptions: [
                { text: "NORMOPIGMENTATA", value: "NORMOPIGMENTATA" },
                { text: "PALLIDA", value: "PALLIDA" },
                { text: "ITTERICA", value: "ITTERICA" },
                { text: "BUASTRA PER CIANOSI", value: "BUASTRA PER CIANOSI" },
            ],
            integritaOptions: [
                { text: "INTEGRA", value: "INTEGRA" },
                { text: "CON PRESENZA DI LESIONI", value: "CON PRESENZA DI LESIONI" },
            ],
            edemiOptions: [
                { text: "PRESENTI", value: "PRESENTI" },
                { text: "ASSENTI", value: "ASSENTI" },
                /* { text: "LIEVI", value: "LIEVI" }, */
            ],
        };
    },
    mounted() {
        let me = this;
        me.loadDizionarioData();
    },
    watch: {
        // Resetto edemiOptions quando cambio il valore di "edemi" === ASSENTI

        "jsonDataCute.edemi": function (newVal) {
            if (newVal !== "PRESENTI") {
                this.selectedEdemi = [];
                this.jsonDataCute.listaSchedaCuteDettagli = [];
                this.listKey++;
                // console.log("Resetto selectedEdemi e listaSchedaCuteDettagli poiché edemi non è 'PRESENTI'");
                // console.log("Nuova listaSchedaCuteDettagli:", this.jsonDataCute.listaSchedaCuteDettagli);
                // console.log("Nuova selectedEdemi:", this.selectedEdemi);
                // console.log("Nuova listKey:", this.listKey);
            }
        },
        jsonDataCute: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        "jsonDataCute.listaSchedaCuteDettagli": {
            handler(lista) {
                if (lista.length > 0) {
                    // Reagisce quando la lista viene popolata dal server
                    this.popolaArrayDaListe();
                }
            },
        },
    },
    methods: {
        onSelectCheckBox() {
            let me = this;
            let listaSchedaCuteDettagli = [];

            me.selectedEdemi.forEach((voce) => {
                listaSchedaCuteDettagli.push({
                    id: null,
                    idSchedaEsameObiettivoGeneraleCute: me.jsonDataCute.id,
                    tipo: "EDEMI",
                    voce: voce,
                });
            });
            me.jsonDataCute.listaSchedaCuteDettagli = listaSchedaCuteDettagli;

            // console.log(" {onSelectCheckBox} Lista EDEMI:", me.selectedEdemi);
            // console.log(" {onSelectCheckBox} Lista Scheda EDEMI Dettagli:", me.jsonDataCute.listaSchedaCuteDettagli);
        },

        popolaArrayDaListe() {
            let me = this;
            me.selectedEdemi = [];
            if (me.jsonDataCute.listaSchedaCuteDettagli.length > 0) {
                me.jsonDataCute.listaSchedaCuteDettagli.forEach((item) => {
                    if (item.tipo === "EDEMI") {
                        me.selectedEdemi.push(item.voce);
                    }
                    // console.log("{ popolaArrayDaListe } Lista EDEMI:", me.selectedEdemi);
                    // console.log(" { popolaArrayDaListe } Lista Scheda EDEMI Dettagli:", me.jsonDataCute.listaSchedaCuteDettagli);
                });
            }
        },

        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },
        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data?.data?.list) {
                me.edemiDettagliOptions = response.data.data.list.filter((item) => item.tipo === "EDEMI");
            }
            if (me.jsonDataCute.listaSchedaCuteDettagli.length > 0) {
                me.popolaArrayDaListe();
            }
        },
        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento delle reazioni di difesa", error);
        },

        onSalvaCute() {
            let me = this;
            me.jsonDataCute.idAccettazione = me.idAccettazione;
            //console.log("Salvataggio CUTE con dati:", JSON.stringify(me.jsonDataCute));
            if (!me.jsonDataCute.idAccettazione) {
                // console.log("idAccettazione: ", me.jsonDataCute.idAccettazione);
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }

            let listaSchedaCuteDettagli = [];
            me.selectedEdemi.forEach((element) => {
                listaSchedaCuteDettagli.push({
                    id: null,
                    idSchedaEsameObiettivoGeneraleCute: me.jsonDataCute.id,
                    tipo: "EDEMI",
                    voce: element,
                });
            });
            me.jsonDataCute.listaSchedaCuteDettagli = listaSchedaCuteDettagli;

            UtilityMixin.methods.saveResource(me.pathResourceSchedaEsameObiettivoGeneraleCute, me.jsonDataCute, me.saveSchedaEsameObiettivoGeneraleCuteSuccessResponse, me.saveSchedaEsameObiettivoGeneraleCuteErrorResponse);
        },
        saveSchedaEsameObiettivoGeneraleCuteSuccessResponse() {
            //console.log("CUTE salvato con successo:", response);
        },
        saveSchedaEsameObiettivoGeneraleCuteErrorResponse() {
            console.error("Errore nel salvataggio CUTE:");
        },
        /*   loadCuteData() {
            let me = this;
            me.selectedEdemi = [];
            me.loadDizionarioData();
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaEsameObiettivoGeneraleCute + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaEsameObiettivoGeneraleCuteSuccess, me.resultResponseSchedaEsameObiettivoGeneraleCuteError);
        },
        resultResponseSchedaEsameObiettivoGeneraleCuteSuccess(response) {
            let me = this;
            me.jsonDataCute = response.data.data;
            me.jsonDataCute.listaSchedaCuteDettagli.forEach((item) => {
                if (item.tipo === "EDEMI") {
                    me.selectedEdemi.push(item.voce);
                }
            });
            // console.log("ID del record CUTE:", me.jsonDataCute.id);
        },
        resultResponseSchedaEsameObiettivoGeneraleCuteError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                //console.log("NESSUN record trovato del CUTE per questo id accettazione");
                me.resetForm();
            } else {
                console.error("Errore nel caricamento dati della sezione CUTE:", error);
            }
        },



 resetForm() {
            let me = this;
            me.jsonDataCute = {
                id: null,
                idAccettazione: me.idAccettazione,
                colorito: null,
                integrita: null,
                integritaDescrizione: null,
                edemi: null,
                noteCute: null,
                listaSchedaCuteDettagli: [],
            };
            me.selectedEdemi = [];
        },

 */
    },
};
</script>
